
import { Action } from 'vuex-class';
import { Vue, Component, Watch } from "vue-property-decorator";
import TaLayoutHeader from "@/components/shared/layout/TaLayoutHeader.vue";
import LayoutLoading from "@/components/shared/layout/FblLayoutLoading.vue";
import LayoutFooter from '@/components/shared/layout/FblLayoutFooter.vue';


@Component({ components: { TaLayoutHeader, LayoutLoading, LayoutFooter } })
export default class ApplicationCallinError extends Vue {
	@Action('setLoading') setLoading;

	// 頁面橫幅
	imgRwd: string = "image_callin_desktop";
	screenWidth: number = 0;

	// 取得畫面寬度
	mounted() {
		this.screenWidth = document.body.clientWidth;

		window.onresize = () => {
			return (() => {
				this.screenWidth = document.body.clientWidth;
			})();
		};
	}


	// 載入橫幅 & 下拉式選單字體大小
	@Watch('screenWidth')
	widthChange() {
		if (this.screenWidth <= 500) {
			this.imgRwd = 'image_callin_mobile';
		} else if (500 < this.screenWidth && this.screenWidth <= 1024) {
			this.imgRwd = 'image_callin_tablet';
		} else {
			this.imgRwd = 'image_callin_desktop';
		}
	}

}
